<template>
  <div>
    <b-row>
      <b-container class="content">
        <b-overlay :show="searchIsRunning">
          <search-form
            :params="model.params"
            @search="runSearch"
          />
        </b-overlay>
        <template v-if="!searchIsRunning">
          <b-card class="mt-3 mt-sm-5 bg-light p-2" no-body v-if="model.results.length">
            <b-row class="align-items-center">
              <b-col md="7">Rezultate</b-col>
              <b-col md="5">
                <sort-fields
                  @sort="onSort"
                  @priceFilter="onPriceFilter"
                />
              </b-col>
            </b-row>
          </b-card>
          <!-- results -->
          <template v-if="model.results.length">
            <div v-for="(result, resultIndex) in filteredResults"  :key="resultIndex">
              <result
                :result="result"
                :key="resultIndex"
                :selected="isSelected(result)"
                :expanded="resultIndex === 0"
                @priceDetails="onPriceDetails({ result })"
                @book="onBook({ ...$event, result })"
                @info="onInfo([result])"
                @toggle="onToggle(result)"
                />
            </div>
          </template>
        </template>
      </b-container>
    </b-row>
    <selected-results
      :results="selectedResults"
      v-show="selectedResults.length"
      @hide="onHideSelected()"
      @info="onInfoSelected()"
    />
    <b-modal v-model="priceDetailsModal" title="Detalii Pret" size="lg" hide-header hide-footer>
      <SimpleModalHeader @closeModal="closePriceDetailsModal" />
      <PriceDetails
        :title="priceDetailsParams.title"
        :meal="priceDetailsParams.meal"
      />
      <ModalFooter @closeModal="closePriceDetailsModal" />
    </b-modal>
    <b-modal v-model="bookModal" title="Rezerva transfer" size="xl" hide-header hide-footer>
      <SimpleModalHeader @closeModal="closeBookModal" />
      <BookForm
        :result="bookInfo.result"
        :params="bookInfo.params"
        @closeModal="closeBookModal"
        @book="onBookingMade"
        :showWebDescriptions="true"
      />
    </b-modal>
    <b-modal v-model="modal" title="Info" size="xl" hide-header hide-footer>
      <div id="printArea">
        <ModalHeader @print="onPrint()" @download="onDownload()" @closeModal="onModalClose" />
        <b-row v-for="(result, resultIndex) in infoResults" :key="'selected' + resultIndex" class="p-4 d-block">
          <result
            :result="result"
            :expanded="true"
            :showBook="false"
            :showWebDescriptions="true"
            />
        </b-row>
      </div>
      <ModalFooter @closeModal="onModalClose" />
    </b-modal>
  </div>
</template>

<script>
import model from './services/model'
import viewMixin from '../shared/mixins/search_views'

import SearchForm from './components/search_form.vue'
import SortFields from './components/sort_fields.vue'
import Result from './components/result'
import SelectedResults from '@/app/private/shared/components/selected_results'

import SimpleModalHeader from '../shared/components/simple_modal_header'
import ModalFooter from '../shared/components/modal_footer'
import ModalHeader from '@/app/private/shared/components/modal_header'
import PriceDetails from '@/app/private/shared/components/price_details'
import BookForm from './components/book_form'
export default {
  name: 'Search',
  components: {
    SearchForm,
    SortFields,
    Result,
    SelectedResults,
    SimpleModalHeader,
    ModalFooter,
    ModalHeader,
    PriceDetails,
    BookForm
  },
  mixins: [viewMixin],
  data () {
    return {
      model,
      priceDetailsParams: {
        meal: null,
        title: ''
      },
      priceDetailsModal: false,
      bookInfo: {
        result: null,
        params: model.params,
        date: null
      },
      modal: false,
      bookModal: false
    }
  },
  methods: {
    onPriceDetails ({ result }) {
      this.priceDetailsParams.title = result.label
      this.priceDetailsParams.meal = {
        price: result.gross,
        commission: result.commission,
        tax: result.tax
      }
      this.priceDetailsModal = true
    },
    onBook ({ result, date }) {
      this.bookInfo.result = result
      this.bookInfo.params = model.params
      this.bookInfo.date = date
      this.bookModal = true
    },
    closePriceDetailsModal () { this.priceDetailsModal = false },
    closeBookModal () { this.bookModal = false },
    runSearch (params) {
      this.searchIsRunning = true
      model.search(params)
        .finally(() => { this.searchIsRunning = false })
    },
    onBookingMade (id) {
      this.$router.push({ name: 'Private/Bookings/View', params: { Id: id } })
    }
  },
  computed: {
    noResults () { return this.model.results.length }
  }
}

</script>

<style lang="scss" scoped></style>
